export default __webpack_public_path__ + "static/media/image.6d98db84.png";